/* eslint-disable react/self-closing-comp */
import {
  Box,
  Menu, Tooltip,
} from '@mui/material';
import { useState } from 'react';
import { FileDownloader } from 'components/FileDownloader';
import { FileUploader } from 'components/FileUploader';

export function ImportIcon({
  columnsForExport,
  title,
  onPost,
  icon,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Tooltip
        title="Importar"
      >
        <Box
          style={{
            display: 'flex', justifyContent: 'center', padding: '4px',
          }}
          onClick={handleClick}
        >
          {icon}
        </Box>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <FileDownloader
          columnsForExport={columnsForExport}
          title={title}
          onClose={handleClose}
        />
        <FileUploader
          onPost={onPost}
          onCloseMenuImport={handleClose}
        />
      </Menu>
    </>
  );
}
